import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import { formatCurrency } from "../../../../../utils/textUtils";

const MaintenanceSalaryCombinationCodeTable = ({ data, onEdit, currentPage, setCurrentPage }) => {
  const headers = ["ID", "Code", "Action"];
  const accessors = ["id", "code","actions"];

  const actions = [{
    name: "Edit",
    icon: <EditIcon fontSize="small" />,
    className: "bg-green-500 hover:bg-green-600",
    function: onEdit,
    visible: true,
  }];

  const customRender = (row, accessor) => {
    if (accessor === "amount") return <span className="font-extrabold text-blue-900">₱{formatCurrency(row[accessor])}</span>;
    return null;
  };

  return (
    <CreateTable
      tableName={"Salary Combination Code List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customCellRenderer={customRender}
    />
  );
};

export default MaintenanceSalaryCombinationCodeTable;